import { render, staticRenderFns } from "./PaymentDialogPeriods.vue?vue&type=template&id=30f6d126&scoped=true&"
import script from "./PaymentDialogPeriods.vue?vue&type=script&lang=js&"
export * from "./PaymentDialogPeriods.vue?vue&type=script&lang=js&"
import style0 from "./PaymentDialogPeriods.vue?vue&type=style&index=0&id=30f6d126&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f6d126",
  null
  
)

/* custom blocks */
import block0 from "./PaymentDialogPeriods.vue?vue&type=custom&index=0&blockType=i18n&lang=yml&locale=ru"
if (typeof block0 === 'function') block0(component)
import block1 from "./PaymentDialogPeriods.vue?vue&type=custom&index=1&blockType=i18n&lang=yml&locale=en"
if (typeof block1 === 'function') block1(component)

export default component.exports